module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 8-070545dce9da43a226fb76a8ad877450.jpg";